<template>
  <div class="mapIsLoading" v-if="isLoading">
    <TheSpinner/>
  </div>
  <OnlyOnClient>
    <YandexMap @created="onInit" :settings="{
      apiKey: '8f9c05f8-5682-4fb4-9616-b81750722ba9',
      lang: 'ru_RU',
      version: '2.1'
  }" style="width: 100%; height: 100%; border-bottom-right-radius: 20px; border-top-right-radius: 20px; overflow: hidden" :zoom="13" :controls="['geolocationControl', 'zoomControl']"
               :coordinates="coordinates">
      <yandexMarker
          v-for="(poly, index) in polygon_list"
          type="Polygon"
          :hint-content="'Доставка из: '+poly.address + ' - '+ poly.description"
          :marker-id="'poly'+index"
          :coordinates="formatPoly(poly.polygons)"
          :marker-fill="{color: poly.color}"
          :options="{
            fillColor: poly.color,
            strokeWidth: 0,
          }"
      />

      <YandexMarker  :options="{
      hintContent: point.name,
        balloonContent: point.address,
      iconLayout: 'default#image',
       iconImageHref: '/assets/img/point_map.svg',
        iconImageSize: [32, 32],
         iconImageOffset: [-16, -32]
    }" v-for="(point, index) in showedPickupList" :key="institution_id"
                    :coordinates="[parseFloat(point.lat), parseFloat(point.lon)]"></YandexMarker>

    </YandexMap>
  </OnlyOnClient>
</template>

<script>

import {YandexMap, YandexMarker} from "vue-yandex-maps/dist/vue-yandex-maps.esm.js";
import { mapState, mapActions, mapGetters } from "vuex";
import TheSpinner from "@/components/TheSpinner.vue";
import OnlyOnClient from "@/components/OnlyOnClient.vue";

export default {
  name: 'ThePickupMap',
  components: {OnlyOnClient, TheSpinner, YandexMap, YandexMarker},
  data() {
    return {
      coordinates: null,
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      pickupList: 'shipping/pickupList'
    }),
    ...mapState({
      'isPolygonsLoaded': state => state.shipping.isPolygonsLoaded,
      'polygons': state => state.shipping.polygons,
      'allPolygons': state => state.shipping.allPolygons,
      'shipping': state => state.shipping.shipping,

      showedPickupList(){
        if(this.injectedPickupList.length > 0){
          return this.injectedPickupList;
        }
        return this.pickupList
      }
    }),
polygon_list() {
       return this.allPolygons?.filter(item => item?.polygons?.length > 0) || [];
     }
  },
  watch: {
    institution_id() {
      this.initCoordinates();
    }
  },
  async created() {
    this.loadPolygonsList()
    this.initCoordinates();
  },
  props: {
    institution_id: {
      default: null
    },
    injectedPickupList: {
      default: []
    },
  },

  methods: {
    ...mapActions({
      loadPolygonsList: 'shipping/loadPolygonsList',
    }),

    formatPoly(data) {
      const formattedData = [];

      data.forEach(point => {
        formattedData.push([point.lat, point.lon]);
      });

      formattedData.push([data[0].lat, data[0].lon]);

      return [formattedData];
    },
    onInit() {
      this.isLoading = false;
    },
    initCoordinates() {
      let institution = null;
      if (this.institution_id) {
        institution = this.showedPickupList.find(value => value.institution_id === this.institution_id);
      } else if (this.shipping?.institution) {
        institution = this.shipping?.institution;
      } else {
        institution = this.pickupList[0];
      }
      if(institution?.lat){
        this.coordinates = [parseFloat(institution.lat), parseFloat(institution.lon)];
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>